import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, NEXT_KEY } from "@/context/AuthContext";

export default function AuthCallback() {
  const { user, onboarding, loading, authError } = useAuth();
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const oauthError = params.get("error_description") || params.get("error");

  useEffect(() => {
    if (loading || !user || !onboarding) return;
    const next = sessionStorage.getItem(NEXT_KEY) || "/app";
    sessionStorage.removeItem(NEXT_KEY);
    const safe = next.startsWith("/") && !next.startsWith("//") ? next : "/app";
    navigate(onboarding.complete ? safe : "/onboarding", { replace: true });
  }, [loading, user, onboarding, navigate]);

  if (!loading && !user && (oauthError || authError)) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4" data-testid="auth-callback-error">
        <div className="panel p-8 max-w-sm text-center space-y-4">
          <h1 className="text-2xl font-bold">Sign-in didn't complete</h1>
          <p className="text-sm text-muted-foreground">{oauthError || authError}</p>
          <Link to="/login" className="inline-flex h-11 px-6 items-center rounded-full brand-gradient text-white font-semibold">Try again</Link>
        </div>
      </div>
    );
  }
  if (!loading && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-empty">
        <Link to="/login" className="text-primary">Back to sign in</Link>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
